import Request from 'gd-request';

class ApiMyWork {

    constructor() {

    }

    // My TASKS
    getMyTasks(viewType, fields, userId = null) {
        // GET http://{{api-app}}/my-work/my-tasks?viewType=assigned-to-me
        // View types:
        // viewType=action-required
        // viewType=assigned-to-me
        // viewType=involved-in
        // viewType=created-by-me
        // viewType=someday
        // viewType=pastdue

        const params = {viewType, userId}

        _.map(fields, field => params[field] = true)

        return new Request(this,'GET','my-work/my-tasks', params);
    }

    myCalendar(events, startDate, endDate, userId) {
        /*return new Request(this,'GET','my-work/my-calendar', {
            events: events.toString(),
            startDate: gd.utils.momentToDate(startDate),
            endDate: gd.utils.momentToDate(endDate),
            userId: userId ? userId : null,
        });*/

        const params = {
            projectIds  : [],
            userIds     : [userId ? userId : gd.user.id],
            eventTypes  : events,
            startDate   : gd.utils.momentToDate(startDate),
            endDate     : gd.utils.momentToDate(endDate)
        }

        return new Request(this,'POST','uds/calendar', params)
    }

    // this is old depricted and maybe not in use but check (!)
    getEvents(startDate, endDate, userId) {
        return new Request(this,'GET','my-work/events', {
            startDate: gd.utils.momentToDate(startDate),
            endDate: gd.utils.momentToDate(endDate),
            userId: userId ? userId : null,
        });
    }

    // deprecated
    myMeetings(startDate, endDate, userId = null) {
        return new Request(this,'GET','my-work/my-meetings', {
            startDate: gd.utils.momentToDate(startDate),
            endDate: gd.utils.momentToDate(endDate),
            userId: userId,
        });
    }

    viewForTodayAssigned(userId) {
        return new Request(this,'GET','my-work/view-for/today-assigned', {
            userId: userId
        });
    }

    viewForData(userId) {
        return new Request(this,'GET','my-work/view-for', {
            userId
        });
    }

    /*viewForTodayActionRequired(userId) {
        return new Request(this,'GET','my-work/view-for/today-action-required', {
            userId: userId
        });
    }

    viewForWeekActionRequired(userId) {
        return new Request(this,'GET','my-work/view-for/week-action-required', {
            userId: userId
        });
    }*/

    viewForWeekAssigned(userId, startDate, endDate) {
        return new Request(this,'GET','my-work/view-for/workload', {
            userId: userId,
            startDate: gd.utils.momentToDate(startDate),
            endDate: gd.utils.momentToDate(endDate),
        });
    }

    // THIS IS OLD for my work AR tasks
    getActionRequiredTasks(userId) {
        const requestParams = userId ? {userId: userId} : {};
        return new Request(this,'GET','my-work', requestParams);
    }

    // OLD
    // getAssignedToTasks(userId) {
    //     const requestParams = userId ? {userId: userId} : {};
    //     return new Request(this,'GET','my-work/assigned-to', requestParams);
    // }

    // OLD
    // getAllInvolvedTasks(userId) {
    //     const requestParams = userId ? {userId: userId} : {};
    //     return new Request(this,'GET','my-work/all-involved', requestParams);
    // }

    getRecentTasks(taskIds) {
        return new Request(this,'POST','tasks/recent-new',{'tasks':taskIds});
    }

    savePositions(data) {
        return new Request(this,'put','my-work/save-positions',data);
    }

    scheduleEvent(notificationId, eventId, scheduleDate, positions) {

        return new Request(this,'put','my-work/'+notificationId+'/schedule-event',{
            eventId: eventId,
            scheduleDate: gd.utils.momentToDate(scheduleDate),
            positions: positions,
        });
    }

    saveDNDResult(data) {
        return new Request(this,'put','my-work',data);
    }

    // deleteReport(reportId, reportType) {
    //     return new Request(this,'put','my-work',{
    //         action      : 'deleteReport',
    //         id          : reportId,
    //         reportType  : reportType
    //     });
    // }

    scheduleTaskToDate(myWorkId, taskId, scheduleDate, positions) {

        // Experimental
        return gd.api.Task.schedule(taskId, scheduleDate);

        // return new Request(this,'put','my-work/'+myWorkId+'/schedule-task',{
        //     taskId: taskId,
        //     scheduleStatus: gd.const.task.scheduleStatus.SCHEDULED,
        //     scheduleDate: scheduleDate.format('YYYY-MM-DD'),
        //     positions: positions
        // });
    }

    scheduleTaskSomeday(myWorkId, taskId, positions) {

        return gd.api.Task.scheduleSomeday(taskId);

        // return new Request(this,'put','my-work/'+myWorkId+'/schedule-task',{
        //     taskId: taskId,
        //     scheduleStatus: gd.const.task.scheduleStatus.SOMEDAY,
        //     positions: positions
        // });
    }

    scheduleTaskInbox(myWorkId, taskId, positions) {

        return gd.api.Task.scheduleNotScheduled(taskId);

        // return new Request(this,'put','my-work/'+myWorkId+'/schedule-task',{
        //     taskId: taskId,
        //     scheduleStatus: gd.const.task.scheduleStatus.NOT_SCHEDULED,
        //     positions: positions
        // });
    }

    markRead(notificationId) {
        return new Request(this, 'PUT', 'my-work/' + notificationId + '/read');
    }

    getSortPositions(userId) {
        return new Request(this,'GET','my-work/sort-positions', {
            userId
        });
    }

    setSortPositions(userId, sortPositions) {
        return new Request(this,'POST','my-work/sort-positions?userId={0}'.f(userId), {
            sortPositions
        });
    }

    updateSortPositions(userId, sortPositions) {
        return new Request(this,'PUT','my-work/sort-positions?userId={0}'.f(userId), {
            sortPositions
        });
    }
}


module.exports = ApiMyWork;